export const SUN_RISE_START = 'SUN_RISE_START';
export const SUN_RISE_FINISHED = 'SUN_RISE_FINISHED';
export const USER_ACTIVE_START = 'USER_ACTIVE_START';
export const USER_ACTIVE_FINISHED = 'USER_ACTIVE_FINISHED';
export const UPDATE_MOUSE_POSITION = 'UPDATE_MOUSE_POSITION';
export const MENU_UPDATE_LANGUAGE_SUCCESS = 'MENU_UPDATE_LANGUAGE_SUCCESS';
export const MENU_UPDATE_TOPIC = 'MENU_UPDATE_TOPIC';